var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasSearched)?_c('div',{staticClass:"pixabay-info-text"},[_vm._v("\n    "+_vm._s(_vm.translations.query)+"\n")]):(!_vm.loading && !_vm.images.length && _vm.hasSearched)?_c('div',{staticClass:"pixabay-info-text"},[_vm._v("\n    "+_vm._s(_vm.translations.noResults)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }